import { init as initSentry } from 'sletat-sentry';


export function init(): void {
    initSentry({
        dsn: 'https://33e688e0957d408193a18d85f5ed00b7@sentry.sletat.ru/5',
        release: __BUILD_VERSION__,
        environment: process.env.NODE_ENV
    });
}
